export enum CardTypeEnum {
  DEFAULT = 'default',
  ACTIVE = 'active',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  HELP = 'help'
}

export enum CardBorderStyleEnum {
  NONE = 'none',
  DEFAULT = 'default',
  DASHED = 'dashed',
  ACTIVE = 'active',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  HELP = 'help'
}

export enum CardPaddingEnum {
  NONE = 'none',
  SMALL = 'small',
  DEFAULT = 'default',
  LARGE = 'large',
  EXTRA = 'extra'
}
